import { Grid, Typography } from "@mui/material"

const THANK_YOU_TEXT = {
    "lim_360_assessment": (name) =>
        `Thank you for completing the Leaders in Motion<sup>&reg;</sup> 360-assessment. Your honest and thoughtful feedback is invaluable in helping <strong>${name}</strong> gain meaningful insight into their management strengths and areas for growth. The perspectives shared by reviewers like you are what make this process truly impactful. Your individual responses will remain confidential and will be combined with feedback from other participants to create a comprehensive development profile. We appreciate your time and commitment to supporting <strong>${name}'s</strong> leadership journey.`,
    "mim_360_assessment": (name) =>
        `Thank you for completing the Managers in Motion<sup>&reg;</sup> 360-assessment. Your honest and thoughtful feedback is invaluable in helping <strong>${name}</strong> gain meaningful insight into their management strengths and areas for growth. The perspectives shared by reviewers like you are what make this process truly impactful. Your individual responses will remain confidential and will be combined with feedback from other participants to create a comprehensive development profile. We appreciate your time and commitment to supporting <strong>${name}'s</strong> leadership journey.`,
};

const Thanks360 = ({mainImage,name,revieweeName,assessmentSlug,isReviewee}) => {

    const getThankYouContent = () => {
        // Reviewees (self-assessment) see the generic thank you, not the reviewer-specific text
        if (!isReviewee && revieweeName && assessmentSlug && THANK_YOU_TEXT[assessmentSlug]) {
            return THANK_YOU_TEXT[assessmentSlug](revieweeName);
        }
        return null;
    };

    const personalizedText = getThankYouContent();

    // Simple 360 Feedback ends with just "Thank you!" and no message.
    if (assessmentSlug === "simple_360_feedback") {
        return (
          <Grid container spacing={5} sx={{padding:"50px"}}>
              <Grid size={6}>
                  <Typography variant="h3" color="primary" fontWeight={600} sx={{marginTop:"40px",lineHeight:"1.3"}}>Thank you!</Typography>
              </Grid>
              <Grid size={6} display="flex" justifyContent="center">
                  <img className="assesmentMainImageBig" src={mainImage} alt="Assessment Logo"/>
              </Grid>
          </Grid>
        );
    }

    return (
      <Grid container spacing={5} sx={{padding:"50px"}}>
          <Grid size={6}>
              {personalizedText ? (
                  <>
                      <Typography variant="h4" color="primary" fontWeight={600} sx={{marginTop:"40px",lineHeight:"1.3"}}>THANK YOU</Typography>
                      <Typography component="div" variant="body1" color="secondary" fontWeight={400} sx={{marginTop:"24px",lineHeight:"1.7",fontSize:"1.05rem"}} dangerouslySetInnerHTML={{ __html: personalizedText }}/>
                  </>
              ) : (
                  <>
                      <Typography variant="h5" color="secondary" fontWeight={400} sx={{marginTop:"40px",lineHeight:"1.5"}}>Thank you for completing the {name}.</Typography>
                      <Typography variant="h3" color="primary" fontWeight={400} sx={{marginTop:"40px",lineHeight:"1.5"}}>Have a nice day!</Typography>
                  </>
              )}
          </Grid>
          <Grid size={6} display="flex" justifyContent="center">
              <img className="assesmentMainImageBig" src={mainImage} alt="Assessment Logo"/>
          </Grid>
      </Grid>
    )
}

export default Thanks360
